// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__GL8Se","newExpiryDate":"styles_newExpiryDate__11gNO","footer":"styles_footer__1cyS0"};